// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-0e0222a6]:export {\n  menuBg: #393997;\n  menuText: #fff;\n  menuActiveText: #409eff;\n}\n\n/* Mixins */\n.edit-input[data-v-0e0222a6] {\n  padding-right: 100px;\n}\n.cancel-btn[data-v-0e0222a6] {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}\n.el-collapse-item .el-collapse-item__header.is-active[data-v-0e0222a6] {\n  color: #F36621 !important;\n}", ""]);
// Exports
module.exports = exports;
